import { useInView } from "../hooks/useInView";

/**
 * Reveal — fade + translate up when scrolled into view.
 * Props:
 *   - as:    HTML tag (default 'div')
 *   - delay: ms (default 0)
 *   - y:     px translateY initial (default 24)
 *   - duration: ms (default 800)
 */
export const Reveal = ({
  as: Tag = "div",
  delay = 0,
  y = 24,
  duration = 800,
  className = "",
  children,
  ...rest
}) => {
  const { ref, inView } = useInView({ threshold: 0.15 });

  const style = {
    transition: `opacity ${duration}ms cubic-bezier(0.16, 1, 0.3, 1) ${delay}ms, transform ${duration}ms cubic-bezier(0.16, 1, 0.3, 1) ${delay}ms`,
    opacity: inView ? 1 : 0,
    transform: inView ? "translateY(0)" : `translateY(${y}px)`,
    willChange: "opacity, transform",
  };

  return (
    <Tag ref={ref} className={className} style={style} {...rest}>
      {children}
    </Tag>
  );
};

export default Reveal;
